import { useMemo } from 'react'

import { getProjectPanelAspect } from '../../lib/comicProjectSettings'
import { buildReaderEpisodeMap,buildReaderPageEntries, filterReaderEntries } from '../../lib/comicReaderModel'
import type { ComicEpisode, ComicProject } from '../../lib/comicTypes'
import { ComicReaderOverlay } from './reader/ComicReaderOverlay'
import { ComicReaderShell } from './reader/ComicReaderShell'

type Props = {
  open: boolean
  angular: boolean
  project: ComicProject
  episode: ComicEpisode
  onClose: () => void
  onSelectPage?: (pageId: string) => void
  onSelectPanel?: (panelId: string) => void
}

export function ComicWebtoonReaderModal({
  open,
  angular,
  project,
  episode,
  onClose,
  onSelectPage,
  onSelectPanel,
}: Props) {
  const panelAspect = getProjectPanelAspect(project)
  const allEntries = useMemo(() => buildReaderPageEntries(project), [project])
  const episodesById = useMemo(() => buildReaderEpisodeMap(project), [project])
  const entries = useMemo(
    () =>
      filterReaderEntries(allEntries, episodesById, { webtoonOnly: true }).filter(
        (e) => e.episodeId === episode.id,
      ),
    [allEntries, episodesById, episode.id],
  )

  const onNavigatePage = onSelectPage
    ? (episodeId: string, pageId: string, panelId?: string) => {
        if (episodeId !== episode.id) return
        onSelectPage(pageId)
        if (panelId) onSelectPanel?.(panelId)
      }
    : undefined

  return (
    <ComicReaderOverlay
      open={open}
      angular={angular}
      title={episode.title}
      subtitle="连续阅读 · 条漫版式"
      onClose={onClose}
    >
      {entries.length === 0 ? (
        <p className="typo-lib-empty flex flex-1 items-center justify-center px-6 py-16 text-center text-ink-soft">
          本话暂无条漫版式页面（条漫三格 / 四格）
        </p>
      ) : (
        <ComicReaderShell
          angular={angular}
          entries={entries}
          episodesById={episodesById}
          panelAspect={panelAspect}
          webtoonOnly
          initialMode="scroll"
          onNavigatePage={onNavigatePage}
        />
      )}
    </ComicReaderOverlay>
  )
}
